import { CloudDrizzle, CloudFog, CloudRain, CloudSnow, CloudSun, Sun, Zap } from 'lucide-react';

interface WeatherCodeIconProps {
  code?: number | null;
  size?: number;
}

export function WeatherCodeIcon({ code, size = 28 }: WeatherCodeIconProps) {
  const props = { size, strokeWidth: 1.75, className: 'text-amber-500 dark:text-amber-400' };
  if (code == null) return <CloudSun {...props} />;
  if (code === 0) return <Sun {...props} />;
  if (code <= 3) return <CloudSun {...props} />;
  if (code <= 48) return <CloudFog {...props} className="text-gray-500 dark:text-gray-400" />;
  if (code <= 55) return <CloudDrizzle {...props} className="text-sky-500 dark:text-sky-400" />;
  if (code <= 67) return <CloudRain {...props} className="text-sky-600 dark:text-sky-400" />;
  if (code <= 77) return <CloudSnow {...props} className="text-sky-300 dark:text-sky-200" />;
  if (code <= 82) return <CloudRain {...props} className="text-sky-600 dark:text-sky-400" />;
  if (code <= 86) return <CloudSnow {...props} className="text-sky-300 dark:text-sky-200" />;
  return <Zap {...props} className="text-violet-500 dark:text-violet-400" />;
}
